import React, { useState, useEffect } from 'react'
import { CircularProgress } from '@material-ui/core'
import moment from 'moment'

function renderInterval({ start, end, baseElapsedSeconds = 0, short = false, medium = false, compact = false, prefix = '' }) {
  let diffMs = 0

  if (start) {
    /** diff from start until now (ms), plus baseElapsed (seconds -> ms) */
    diffMs = moment().diff(start, 'milliseconds') + (baseElapsedSeconds * 1000)
  } else if (end) {
    /** countdown: time remaining until end; baseElapsed doesn't apply here */
    diffMs = moment(end).diff(moment(), 'milliseconds')
  } else {
    return ""
  }

  const absMs = Math.abs(diffMs)

  if (medium) {
    const duration = moment.duration(absMs)
    const d = Math.floor(duration.asDays())
    const t = moment.utc(duration.asMilliseconds()).format('HH:mm:ss')
    if (d > 0) {
      return `${prefix}${d}d ${t}`
    } else {
      return `${prefix}${t}`
    }
  } else if (short) {
    const duration = moment.duration(absMs)
    const d = Math.floor(duration.asDays())
    const h = duration.hours()
    const m = duration.minutes()
    let parts = []
    if (d) parts.push(`${d}d`)
    if (h) parts.push(`${h}h`)
    if (m || (!d && !h)) parts.push(`${m}m`)
    return `${prefix}${parts.join(' ')}`
  } else if (compact) {
    const duration = moment.duration(absMs)
    if (duration.asHours() < 1) {
      return moment.utc(duration.asMilliseconds()).format('mm:ss')
    }
    return moment.utc(duration.asMilliseconds()).format('HH:mm:ss')
  } else {
    const duration = moment.duration(absMs)
    const d = duration.days() > 0 ? `${duration.days()} day(s) ` : ''
    const m = duration.months() > 0 ? `${duration.months()} month(s) ` : ''
    const y = duration.years() > 0 ? `${duration.years()} year(s) ` : ''
    const t = moment.utc(duration.asMilliseconds()).format('HH:mm:ss')
    return `${y}${m}${d}${t}`
  }
}

export const Counter = ({ start, end, baseElapsedSeconds = 0, style = {}, short = false, medium = false, compact = false, prefix = '', onTick }) => {
  const [count, setCount] = useState(() => renderInterval({ start, end, baseElapsedSeconds, short, medium, compact, prefix }))

  useEffect(() => {
    /** immediate update on prop change */
    const tick = () => {
      const next = renderInterval({ start, end, baseElapsedSeconds, short, medium, compact, prefix })
      setCount(next)

      if (onTick) {
        let diffSec = 0
        if (start) {
          /** add baseElapsedSeconds to live diff */
          diffSec = Math.floor((moment().diff(start, 'seconds')) + baseElapsedSeconds)
        } else if (end) {
          diffSec = Math.floor(moment(end).diff(moment(), 'seconds'))
        }
        onTick(diffSec)
      }
    }

    /** run immediately and every second */
    tick()
    const timer = window.setInterval(tick, 1000)

    return () => {
      window.clearInterval(timer)
    }
  }, [start, end, baseElapsedSeconds, short, medium, compact, prefix, onTick])

  if (count)
    return (
      <div style={style}>
        {count}
      </div>
    )

  return <CircularProgress size={20} />
}

export default Counter
